<template>
  <span v-if="field.errorMessage" class="text-red-500 text-xs w-4">{{ field.errorMessage }}</span>
</template>

<script setup lang="ts">
import { useField } from "@xs2event/js-lib/validation";

const props = defineProps<{ name: string }>();

const field = useField(props.name);
</script>
